import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import CategoryModel from '@/store/Models/Category';
// TODO: Move api to module/api folder
import QuilityAPI from '@/store/API/QuilityAPI';
import EditCategoryModal from '../components/EditCategoryModal.vue';

import Header from '../components/Header.vue';
import List from '../components/List.vue';

import { Category } from '../types/Category';
import AddNewCategoryButton from '../components/AddNewCategoryButton.vue';
import DeleteCategoryModal from '../components/DeleteCategoryModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoriesDataTable',
  setup(__props) {

const items = computed({
  get() {
    return CategoryModel.query().get() as unknown as Category[]
  },
  set(data: Category[]) {
    CategoryModel.deleteAll()
    CategoryModel.insertOrUpdate({ data })
    QuilityAPI.reorderCategories(data)
  }
})

const refreshData = () => {
  QuilityAPI.refreshCategories()
}

const updateCategory = (category: Category) => {
  doEditModalSaving.value = true

  if (category.id === -1) {
    QuilityAPI.createCategory(category).finally(() => {
      doEditModalSaving.value = false
      doShowEditModal.value = false
    })
  }
  QuilityAPI.saveCategory(category).finally(() => {
    doEditModalSaving.value = false
    doShowEditModal.value = false
  })
}

const doShowEditModal = ref(false)
const editCategoryModalTitle = ref<'Update Category' | 'Create Category'>('Update Category')
const categoryToEdit = ref<Category | null>(null)
const doEditModalSaving = ref(false)
const possibleParentCategories = computed(() => {
  return items.value
    .filter((c) => c.parent_category_id === null)
    .sort((a, b) => a.order - b.order)
    .filter((c) => c.id !== categoryToEdit.value?.id)
})

const showEditCategoryModal = (category: Category) => {
  editCategoryModalTitle.value = 'Update Category'
  categoryToEdit.value = category
  doShowEditModal.value = true
}

const showAddSubcategoryModal = (parentCategory: Category) => {
  editCategoryModalTitle.value = 'Create Category'

  const newCategory: Category = {
    category: '',
    description: '',
    zendesk_category_id: 0,
    parent_category_id: parentCategory.id,
    order: 0,
    id: -1,
  }
  
  categoryToEdit.value = newCategory
  doShowEditModal.value = true
}

const addCategory = () => {
  editCategoryModalTitle.value = 'Create Category'

  const newCategory: Category = {
    category: '',
    description: '',
    zendesk_category_id: 0,
    parent_category_id: null,
    order: 0,
    id: -1,
  }
  
  categoryToEdit.value = newCategory
  doShowEditModal.value = true
}

const categoryToDelete = ref<Category | null>(null)
const doShowDeleteModal = ref(false)

const showDeleteCategoryModal = (category: Category) => {
  categoryToDelete.value = category
  doShowDeleteModal.value = true
}

const deleteCategory = (category: Category) => {
  QuilityAPI.deleteCategory(category.id)
    .then((resp) => {
		if (resp.success === true) {
			CategoryModel.delete(category.id)
		} else {
			this.showError(resp.msg);
		}
    })
    .finally(() => {
      doShowDeleteModal.value = false
    })
}

const errorAlertMessage = ref('')
const doShowErrorAlert = computed({
  get() {
    return errorAlertMessage.value !== ''
  },
  set(v) {
    if (!v) {
      errorAlertMessage.value = ''
    }
  }
})

return { __sfc: true,items, refreshData, updateCategory, doShowEditModal, editCategoryModalTitle, categoryToEdit, doEditModalSaving, possibleParentCategories, showEditCategoryModal, showAddSubcategoryModal, addCategory, categoryToDelete, doShowDeleteModal, showDeleteCategoryModal, deleteCategory, errorAlertMessage, doShowErrorAlert, EditCategoryModal, Header, List, AddNewCategoryButton, DeleteCategoryModal }
}

})